import { c as _c } from "react/compiler-runtime";
import type { ProxyConfigBasic } from '@onefootprint/request-types/dashboard';
import { Table as UITable } from '@onefootprint/ui';
import { useRouter } from 'next/router';
import { useTranslation } from 'react-i18next';
import useMobileLayout from '@/hooks/use-mobile-layout';
import MobileRow from './mobile-row';
import Row from './row';
type TableProps = {
  data?: ProxyConfigBasic[];
  errorMessage?: string;
  isPending?: boolean;
};
const Table = t0 => {
  const $ = _c(57);
  const {
    data,
    isPending,
    errorMessage
  } = t0;
  const {
    t
  } = useTranslation("vault-proxy");
  const router = useRouter();
  const isMobile = useMobileLayout();
  let t1;
  if ($[0] !== t) {
    t1 = t(_temp);
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = {
      id: "name",
      text: t1,
      width: "17%"
    };
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t) {
    t3 = t(_temp2);
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t3) {
    t4 = {
      id: "id",
      text: t3,
      width: "20%"
    };
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t) {
    t5 = t(_temp3);
    $[8] = t;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t5) {
    t6 = {
      id: "url",
      text: t5,
      width: "22%"
    };
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t) {
    t7 = t(_temp4);
    $[12] = t;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t7) {
    t8 = {
      id: "http",
      text: t7,
      width: "12%"
    };
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t) {
    t9 = t(_temp5);
    $[16] = t;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t9) {
    t10 = {
      id: "status",
      text: t9,
      width: "12%"
    };
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t) {
    t11 = t(_temp6);
    $[20] = t;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== t11) {
    t12 = {
      id: "created",
      text: t11,
      width: "12%"
    };
    $[22] = t11;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = {
      id: "actions",
      text: "",
      width: "5%"
    };
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== t10 || $[26] !== t12 || $[27] !== t2 || $[28] !== t4 || $[29] !== t6 || $[30] !== t8) {
    t14 = [t2, t4, t6, t8, t10, t12, t13];
    $[25] = t10;
    $[26] = t12;
    $[27] = t2;
    $[28] = t4;
    $[29] = t6;
    $[30] = t8;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  const columns = t14;
  let t15;
  if ($[32] !== t) {
    t15 = t(_temp7);
    $[32] = t;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  let t16;
  if ($[34] !== t15) {
    t16 = {
      id: "name",
      text: t15
    };
    $[34] = t15;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  let t17;
  if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = {
      id: "actions",
      text: "",
      width: "68px"
    };
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  let t18;
  if ($[37] !== t16) {
    t18 = [t16, t17];
    $[37] = t16;
    $[38] = t18;
  } else {
    t18 = $[38];
  }
  const mobileColumns = t18;
  let t19;
  if ($[39] !== router) {
    t19 = proxyConfig => {
      router.push({
        pathname: `/developers/vault-proxy/${proxyConfig.id}`
      });
    };
    $[39] = router;
    $[40] = t19;
  } else {
    t19 = $[40];
  }
  const handleClick = t19;
  let t20;
  if ($[41] !== t) {
    t20 = t(_temp8);
    $[41] = t;
    $[42] = t20;
  } else {
    t20 = $[42];
  }
  const t21 = isMobile ? mobileColumns : columns;
  let t22;
  if ($[43] !== errorMessage || $[44] !== t) {
    t22 = errorMessage || t(_temp9);
    $[43] = errorMessage;
    $[44] = t;
    $[45] = t22;
  } else {
    t22 = $[45];
  }
  let t23;
  if ($[46] !== isMobile) {
    t23 = t24 => {
      const {
        item: proxyConfig_2
      } = t24;
      return isMobile ? <MobileRow proxyConfig={proxyConfig_2} /> : <Row proxyConfig={proxyConfig_2} />;
    };
    $[46] = isMobile;
    $[47] = t23;
  } else {
    t23 = $[47];
  }
  let t24;
  if ($[48] !== data || $[49] !== handleClick || $[50] !== isMobile || $[51] !== isPending || $[52] !== t20 || $[53] !== t21 || $[54] !== t22 || $[55] !== t23) {
    t24 = <UITable aria-label={t20} columns={t21} emptyStateText={t22} getAriaLabelForRow={_temp10} getKeyForRow={_temp11} hideThead={isMobile} isLoading={isPending} items={data} onRowClick={handleClick} renderTr={t23} />;
    $[48] = data;
    $[49] = handleClick;
    $[50] = isMobile;
    $[51] = isPending;
    $[52] = t20;
    $[53] = t21;
    $[54] = t22;
    $[55] = t23;
    $[56] = t24;
  } else {
    t24 = $[56];
  }
  return t24;
};
export default Table;
function _temp($) {
  return $.table.header.name;
}
function _temp2($_0) {
  return $_0.table.header.id;
}
function _temp3($_1) {
  return $_1.table.header.url;
}
function _temp4($_2) {
  return $_2.table.header.method;
}
function _temp5($_3) {
  return $_3.table.header.status;
}
function _temp6($_4) {
  return $_4.table.header.createdAt;
}
function _temp7($_5) {
  return $_5.table.header.name;
}
function _temp8($_6) {
  return $_6.table.ariaLabel;
}
function _temp9($_7) {
  return $_7.table.emptyState;
}
function _temp10(proxyConfig_0) {
  return proxyConfig_0.name;
}
function _temp11(proxyConfig_1) {
  return proxyConfig_1.id;
}